module.exports = __webpack_public_path__ + "img/bplogo_dark.b8d34475.svg";